export type UnwrapWethMethodName =
    | 'unwrapWETH9'
    | 'unwrapWNativeToken'
    | 'unwrapWeth'
    | 'WETH9'
    | 'unwrapWNat';
